import React, { useEffect, useMemo, useState, useRef } from "react";
import FaceBook from "../../../images/SocialMediaGif/Facebook.png";
import Phone from "../../../images/SocialMediaGif/telephone.png";
import Wave from "../../../images/SocialMediaGif/wave.png";
import { FaPhoneSquare, FaRegUser } from "react-icons/fa";
import { MdArrowBackIos } from "react-icons/md";
import Select from "react-select";
import OtpInput from "./OtpInput";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountryName } from "../../../redux/actions/commonApiActions";
import GoogleLogin from "./GoogleLogin";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  keyCloakLoader,
  loginErrorUpdate,
  updateKeyCloakToken,
  mobileNumberRegister,
  registerErrorUpdate,
  socialKeyClockLoginAction,
  getRefreshTokenDetails,
  getUserDetailsByToken,
} from "../../../redux/actions/loginDetailsActions";
import Swal from "sweetalert2";
import ErrorUser from "../ErrorUser";
import { withRouter } from "react-router-dom";
import {
  CLIENT_ID,
  GOOGLE_CLIENT_ID,
  KEY_CLOAK_URL,
} from "../../../config/keycloak-config";
import Email from "../../../images/SocialMediaGif/mail.png";
import MailRegister from "./MailRegister";
import { toast } from "react-toastify";
import LoginService from "../../../api/LoginService";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import MeetingExpiry from "./MeetingExpiry";
import { getLocalStorage } from "../../../utils";
import Notfound from "../../../images/icons/page-not-found.png";
import { language } from "../../../sampleData/Options";
import { dBody } from "../../../components/Utils";
import ProfileService from "../../../api/ProfileService";
import YuukkeLightLogo from "../../../images/yuukkelogofordark.png";

// Extracted stylesheet (previously an inline <style dangerouslySetInnerHTML> block)
import "./AuthContainer.css";

// Icons for the new UI (Added Calendar, MapPin, Globe, ShieldCheck for left-side UI)
import {
  LuArrowLeft as ArrowLeft,
  LuLoader2 as Loader2,
  LuSparkles as Sparkles,
  LuSend as Send,
  LuCalendar as Calendar,
  LuMapPin as MapPin,
  LuUsers as Users,
  LuShoppingBag as ShoppingBag,
  LuHeartHandshake as HeartHandshake,
  LuGraduationCap as GraduationCap,
  LuLifeBuoy as LifeBuoy,
  LuRocket as Rocket
} from "react-icons/lu";

const AuthContainer = (props) => {
  // ==========================================
  // 1. ORIGINAL LOGIC & STATE (100% UNTOUCHED)
  // ==========================================
  const countryList = useSelector((state) => state.commonApi.countryName);
  const {
    loginLoader,
    loginError,
    userLoggedIn,
    loginUserError,
    loginDetails,
    registerErrorStatus,
    loginErrorMessage,
  } = useSelector((state) => state.loginDetailsApi);

  const details = {
    name: "",
    country: "",
    phoneNumber: "",
    menu: 0,
    countryList: [],
    otp: "",
    signInStatus: "",
    onResentOtp: false,
    email: null,
    language: { label: "English", value: "English" },
  };

  const [state, setState] = useState(details);
  const dispatch = useDispatch();
  const parallaxRef = useRef(null);

  // NEW: guards against double-submit while an OTP verification request is in flight
  const [isVerifying, setIsVerifying] = useState(false);
  // NEW: bump this to force-remount OtpInput (clears its stale internal digits)
  const [otpResetKey, setOtpResetKey] = useState(0);

  useEffect(() => {
    dispatch(keyCloakLoader(false));
    dispatch(getAllCountryName());
    const token = getLocalStorage("R_TOKEN");
    if (!userLoggedIn && token) {
      const details = {
        token: token,
        client_id: CLIENT_ID,
      };
      dispatch(getUserDetailsByToken(details));
    }
  }, []);

  useEffect(() => {
    if (userLoggedIn) {
      props.history.push(
        `/${loginDetails?.defaultWorkSpace
          ? loginDetails?.defaultWorkSpace
          : "default"
        }/home`
      );
    }
    if (loginError) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          loginUserError === "blocked_by_admin"
            ? "Your login has been blocked by the admin. Please contact support"
            : loginErrorMessage
              ? loginErrorMessage
              : "Something went wrong,to login !",
      });
      dispatch(loginErrorUpdate(false));
      setState(details);
    }
    if (registerErrorStatus) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${registerErrorStatus
          ? registerErrorStatus
          : "Something went wrong,please try later !"
          }!`,
      });
      dispatch(registerErrorUpdate(null));
      setState(details);
    }
  }, [loginError, userLoggedIn, registerErrorStatus]);

  useEffect(() => {
    if (countryList.length > 0 && state.countryList?.length === 0) {
      const list = countryList.map((item) => {
        return { value: item.iso, label: item.nicename, id: item.id };
      });
      updateState("countryList", list);
    }
  }, [countryList, state]);

  useEffect(() => {
    if (state.countryList.length > 0 && !state.country) {
      const selectedList = state.countryList.find(
        (country) => country.label === "India"
      );
      updateState("country", selectedList ?? "");
    }
  }, [state.menu]);

  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const onOtpSubmit = (otp) => {
    updateState("otp", otp);
  };

  const getHidedList = () => {
    if (!state.phoneNumber) {
      return "";
    }
    const data = state.phoneNumber.slice(0, -4) + "*".repeat(4);
    return data;
  };
  const previewPhoneNumber = useMemo(() => getHidedList(), [state.phoneNumber]);

  const errorGettingToken = (type, e) => {
    console.error(`Error getting ${type} token :`, e);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong,when try to get your social login details!.",
    });
  };

  // ==========================================
  // FIXED: verifyOtp
  // - guards against double submission
  // - always stops the loader via .finally(), even on unexpected errors
  // - shows exactly one dialog on wrong/invalid OTP instead of a mix of
  //   toasts and silent failures
  // ==========================================
  const showInvalidOtpDialog = () => {
    Swal.fire({
      icon: "error",
      title: "Invalid OTP",
      text: "The OTP you entered is incorrect. Please try again.",
      confirmButtonText: "Try Again",
    }).then(() => {
      updateState("otp", "");
      setOtpResetKey((k) => k + 1); // remount OtpInput so boxes clear and accept new digits
    });
  };

  const showGenericErrorDialog = () => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong, please try again later!",
      confirmButtonText: "OK",
    }).then(() => {
      updateState("otp", "");
      setOtpResetKey((k) => k + 1);
    });
  };

  const verifyOtp = () => {
    // Prevent firing a second request while one is already in flight
    if (isVerifying) return;

    if (!state.otp || state.otp.length !== 6) {
      toast.warning("Please fill valid otp");
      return;
    }

    setIsVerifying(true);
    dispatch(keyCloakLoader(true));

    if (state.signInStatus !== "mobile-signIn") {
      // ---- Registration OTP flow ----
      const data = {
        phoneNumber: state.phoneNumber,
        otp: state.otp,
      };

      LoginService.validateOtp(data)
        .then((response) => {
          if (response.data.data === "VALID_OTP") {
            const registerDetails = {
              name: state.name,
              phoneNumber: state.phoneNumber,
              clientId: CLIENT_ID,
              location: state.country.label,
              email: state.email,
            };
            const loginUpdate = {
              countryId: state.country.id,
              personalLanguage: state.language.value,
              country: state.country.label,
            };
            dispatch(mobileNumberRegister(registerDetails, loginUpdate));
            // NOTE: loader intentionally left ON here — mobileNumberRegister
            // owns turning it off once registration finishes (success or fail).
            // Make sure that action's reducer/saga calls keyCloakLoader(false)
            // in BOTH its success and error branches, or the loader will hang.
          } else {
            showInvalidOtpDialog();
            dispatch(keyCloakLoader(false));
          }
        })
        .catch(() => {
          showGenericErrorDialog();
          dispatch(keyCloakLoader(false));
        })
        .finally(() => {
          setIsVerifying(false);
        });
    } else {
      // ---- Mobile sign-in OTP flow ----
      const data = {
        mobile_number: state.phoneNumber,
        otp: state.otp,
        client_id: CLIENT_ID,
      };

      LoginService.validateLoginOtp(data)
        .then((response) => {
          const result = response.data;
          if (result?.access_token) {
            dispatch(updateKeyCloakToken(result));
          } else {
            showInvalidOtpDialog();
          }
        })
        .catch(() => {
          showInvalidOtpDialog();
        })
        .finally(() => {
          setIsVerifying(false);
          dispatch(keyCloakLoader(false));
        });
    }
  };

  const submitForm = (e, resend) => {
    e.preventDefault();
    e.stopPropagation();
    if (!state.country?.value && !state.signInStatus === "mobile-signIn") {
      toast.warning("Select your country");
    } else if (
      state.phoneNumber.length <= 8 ||
      state.phoneNumber.length >= 16
    ) {
      toast.warning("Enter valid phone number");
    } else {
      dispatch(keyCloakLoader(true));
      let data = {
        phoneNumber: state.phoneNumber,
      };
      if (state.signInStatus === "mobile-signIn") {
        LoginService.phoneExitCheck(data)
          .then((response) => {
            if (response.data.data === "PHONE_NUMBER_EXIST") {
              loginOtpSend(resend);
            } else {
              Swal.fire({
                title: "PHONE NUMBER NOT EXIST",
                showCancelButton: true,
                confirmButtonText: "Create New Account",
                cancelButtonText: "Reenter Phone Number",
                reverseButtons: true,
                icon: "warning",
                iconHtml: `<img src=${Notfound} style="width: 50px; height: 50px;">`,
              }).then((result) => {
                if (result.value) {
                  createAccountPage(2);
                }
              });
            }
            dispatch(keyCloakLoader(false));
          })
          .catch((error) => {
            if (error?.message === "Network Error") {
              Swal.fire({
                title: "Network issue detected. Kindly verify your connection.",
                confirmButtonText: "Tyr Again",
                reverseButtons: true,
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "We encountered an issue. Please log in again!",
                confirmButtonText: "Tyr Again",
                reverseButtons: true,
                icon: "warning",
              });
            }
            dispatch(keyCloakLoader(false));
          });
      } else {
        if (state.email) {
          data.email = state.email;
        }
        LoginService.generateOtp(data)
          .then((response) => {
            if (response.data.data === "OTP_SENT") {
              updateState("menu", 3);
              if (resend) {
                updateState("onResentOtp", !state.onResentOtp);
              }
            } else if (
              response.data.data === "PHONE_NUMBER_ALREADY_REGISTERED"
            ) {
              toast.error(
                "Given mobile number already registered,try to login!"
              );
            } else if (response.data.data === "EMAIL_ALREADY_EXIST") {
              toast.error("Given email already exist,try to new email!");
            } else {
              toast.error("Some thing went wrong ,please try later !");
            }
            dispatch(keyCloakLoader(false));
          })
          .catch((error) => {
            if (error?.message === "Network Error") {
              Swal.fire({
                title: "Network issue detected. Kindly verify your connection.",
                confirmButtonText: "Tyr Again",
                reverseButtons: true,
                icon: "warning",
              });
            } else {
              Swal.fire({
                title:
                  "Access is temporarily unavailable. Please try again later.",
                confirmButtonText: "Tyr Again",
                reverseButtons: true,
                icon: "warning",
              });
            }
            dispatch(keyCloakLoader(false));
          });
      }
    }
  };

  const loginOtpSend = (resend) => {
    axios({
      method: "post",
      url: `${KEY_CLOAK_URL}realms/yuukke/sms-authentication/otp/${state.phoneNumber}`,
    })
      .then((response) => {
        dispatch(keyCloakLoader(false));
        updateState("menu", 3);
        if (resend) {
          updateState("onResentOtp", !state.onResentOtp);
        }
      })
      .catch((e) => {
        updateState("menu", 3);
        dispatch(keyCloakLoader(false));
        if (resend) {
          updateState("onResentOtp", !state.onResentOtp);
        }
      });
  };

  const updateToken = (type, token) => {
    if (token?.access_token) {
      dispatch(socialKeyClockLoginAction(type, token?.access_token));
    } else {
      errorGettingToken(type, token);
    }
  };

  const singInForm = (type) => {
    if (type === "mobile-signIn") {
      setState({
        ...state,
        signInStatus: type,
        menu: 2,
      });
    } else if (type === "mail-signIn") {
      setState({
        ...state,
        signInStatus: type,
        menu: 4,
      });
    }
  };

  const [ip, setIp] = React.useState(null);
  const getIp = () => {
    ProfileService.getIp()
      .then((response) => {
        setIp(response.data.ip);
      })
      .catch((error) => {
        console.error("Error getting IP:", error);
      });
  };

  React.useEffect(() => {
    getIp();
  }, []);

  const backForm = () => {
    if (state.signInStatus) {
      setState({
        ...state,
        signInStatus: "",
        menu: 0,
        name: "",
        country: "",
        phoneNumber: "",
        otp: "",
      });
    } else if (state.menu === 4) {
      updateState("menu", 1);
    } else {
      setState((previous) => ({
        ...previous,
        menu: state.menu - 1,
        name: "",
        phoneNumber: "",
        email: "",
      }));
    }
  };

  const emailRegisterSuccess = (e) => {
    setState(details);
  };

  const createAccountPage = (menu = 2) => {
    setState((previous) => ({
      ...previous,
      signInStatus: "",
      menu: 2,
      name: "",
      phoneNumber: "",
      email: "",
    }));
  };

  // Parallax Effect for Desktop
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!parallaxRef.current) return;
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      parallaxRef.current.style.transform = `perspective(1000px) rotateX(${y * -4
        }deg) rotateY(${x * 4}deg)`;
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  if (
    loginUserError === "blocked_by_admin" ||
    loginUserError === "some_thing_wrong"
  ) {
    return <ErrorUser />;
  }

  // Minimal, unified Dark Theme Styles for React-Select
  // (kept identical shape/height/border to .input-field and react-tel-input
  // so every field on the form reads as one consistent design)
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "rgba(255, 255, 255, 0.04)",
      borderColor: state.isFocused ? "#ff3366" : "rgba(255, 255, 255, 0.12)",
      borderRadius: "14px",
      minHeight: "52px",
      padding: "0 4px",
      outline: "none",
      cursor: "pointer",
      color: "white",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(255,51,102,0.12)" : "none",
      transition: "all 0.25s ease",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.25)",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#1a1a1f" : "#111",
      color: "white",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#ff3366",
        color: "white",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    input: (provided) => ({
      ...provided,
      color: "white",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(255,255,255,0.35)",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#111",
      border: "1px solid rgba(255,255,255,0.1)",
      borderRadius: "14px",
      overflow: "hidden",
    }),
  };

  // ==========================================
  // 2. UI (CSS now lives in ./AuthContainer.css)
  // ==========================================
  return (
    <div className="new-auth-master">
      {/* --- BACKGROUND MESH & BLOBS --- */}
      <div className="aurora-bg">
        <div className="mesh-grid"></div>
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      {/* --- ADVANCED LOADER --- */}
      {loginLoader && (
        <div className="full-loader">
          <div className="loader-core">
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
          </div>
          <div className="loader-text-wrapper">
            <span className="loader-text">Loading Please Wait</span>
            <span className="loader-dots"></span>
          </div>
        </div>
      )}

      {/* --- MAIN LAYOUT --- */}
      <div className="layout-container">

        {/* ================= LEFT SIDE - PURE ANIMATION ================= */}
        <div className="brand-col" ref={parallaxRef} style={{ position: "relative", zIndex: 10 }}>

          {/* Sequential Pop-in Feature Orbs */}
          <div className="feature-constellation">
            <div className="floating-orb orb-1">
              <Users color="#ff3366" size={18} />
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "white" }}>Business Networking</span>
            </div>
            <div className="floating-orb orb-2">
              <ShoppingBag color="#ff3366" size={18} />
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "white" }}>Marketplace Access</span>
            </div>
            <div className="floating-orb orb-3">
              <HeartHandshake color="#ff3366" size={18} />
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "white" }}>Build Your Community</span>
            </div>
            <div className="floating-orb orb-4">
              <GraduationCap color="#ff3366" size={18} />
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "white" }}>Professional Development</span>
            </div>
            <div className="floating-orb orb-5">
              <LifeBuoy color="#ff3366" size={18} />
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "white" }}>Safe Place to Ask Help</span>
            </div>
            <div className="floating-orb orb-6">
              <Rocket color="#ff3366" size={18} />
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "white" }}>Business Growth Support</span>
            </div>
          </div>

          {/* Center Content Wrapper - logo + subtitle centered */}
          <div className="brand-center" style={{ position: "relative", zIndex: 20 }}>
            <img
              src={YuukkeLightLogo}
              alt="Yuukke"
              className="brand-logo-img fade-in-up"
              style={{ animationDelay: "0.3s" }}
            />

            <h2 className="subtitle fade-in-up" style={{ animationDelay: '1s' }}>Building Futures Through Commerce</h2>
          </div>

        </div>

        {/* RIGHT SIDE - FORM CARD WITH LOGO */}
        <div className="form-col fade-in-up" style={{ animationDelay: "0.3s" }}>
          <div className="glass-card">

            {/* Contextual Back Button (Fixed SVG implementation) */}
            {state.menu !== 0 && state.menu !== 3 && (
              <button onClick={backForm} type="button" className="back-btn" title="Go Back">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
            )}

            {/* ================= MENU 0: SIGN IN OPTIONS ================= */}
            {state.menu === 0 && (
              <div className="fade-in-up">

                <div style={{ marginTop: "1.5rem" }}>
                  <button onClick={() => singInForm("mobile-signIn")} className="opt-btn">
                    <img src={Phone} alt="Phone" /> Sign in with Mobile Number
                  </button>

                  <button onClick={() => singInForm("mail-signIn")} className="opt-btn">
                    <img src={Email} alt="Email" /> Sign in with Email
                  </button>

                  <div className="google-btn-wrapper" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                      <GoogleLogin outer={true} updateToken={updateToken} errorGettingToken={errorGettingToken} title="Sign in with Google" />
                    </GoogleOAuthProvider>
                  </div>
                </div>

                <div className="menu-footer">
                  <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.95rem" }}>
                    <span onClick={() => updateState("menu", 1)} className="link-accent">
                      Create New Account
                    </span>
                  </p>
                </div>
                <div style={{ textAlign: "center", marginTop: "0.5rem" }}>
                  <p className="menu-desc">
                    By tapping Sign in, you agree to our{" "}
                    <a href="https://www.yuukke.com/privacy-policy.html" target="_blank" rel="noreferrer" className="link-accent" style={{ textDecoration: "none", borderBottom: "1px dotted rgba(255,255,255,0.3)" }}>Privacy Policy</a>
                  </p>
                </div>
              </div>
            )}

            {/* ================= MENU 1: REGISTER OPTIONS ================= */}
            {state.menu === 1 && (
              <div className="fade-in-up">
                <div className="menu-header text-center">
                  <h3 className="menu-title">Create Account</h3>
                  <p className="menu-desc">Join the Yuukke network today.</p>
                </div>

                <div style={{ marginTop: "2rem" }}>
                  <button onClick={() => updateState("menu", 2)} className="opt-btn">
                    <img src={Phone} alt="Phone" /> Register with Mobile
                  </button>

                  <div className="google-btn-wrapper" style={{ marginTop: "1rem" }}>
                    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                      <GoogleLogin outer={true} updateToken={updateToken} errorGettingToken={errorGettingToken} title="Register with Google" />
                    </GoogleOAuthProvider>
                  </div>
                </div>
              </div>
            )}

            {/* ================= MENU 2: PHONE FORM ================= */}
            {state.menu === 2 && (
              <div className="fade-in-up">
                <div className="menu-header">
                  <h3 className="menu-title" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {state.signInStatus === "mobile-signIn" ? "" : "Let's Start"}
                    {state.signInStatus !== "mobile-signIn" && <img src={Wave} alt="Wave" style={{ width: "28px", height: "28px" }} />}
                  </h3>
                  <p className="menu-desc">
                    {state.signInStatus === "mobile-signIn" ? "Enter your registered mobile number" : "Please provide your details"}
                  </p>
                </div>

                <form onSubmit={(e) => submitForm(e, false)}>
                  {state.signInStatus !== "mobile-signIn" && (
                    <>
                      {/* Name */}
                      <div className="input-group">
                        <label htmlFor="name" className="static-label">What is your name? *</label>
                        <div className="input-wrapper">
                          <FaRegUser className="input-icon" />
                          <input required type="text" id="name" placeholder="Enter your name" className="input-field" value={state.name} onChange={(e) => updateState("name", e.target.value)} />
                        </div>
                      </div>

                      {/* Country Select */}
                      <div className="input-group">
                        <label className="static-label">Country *</label>
                        <Select onChange={(e) => updateState("country", e)} options={state.countryList} value={state.country} placeholder="Select Country" styles={customStyles} required={true} menuPortalTarget={dBody} />
                      </div>

                      {/* Language Select */}
                      <div className="input-group">
                        <label className="static-label">Language *</label>
                        <Select onChange={(e) => updateState("language", e)} options={language} value={state.language} placeholder="Select Language" styles={customStyles} required={true} menuPortalTarget={dBody} />
                      </div>

                      {/* Email */}
                      <div className="input-group">
                        <label htmlFor="email" className="static-label">Email Address (Optional)</label>
                        <div className="input-wrapper">
                          <img src={Email} alt="Email" className="input-icon" style={{ filter: "none" }} />
                          <input type="email" id="email" placeholder="you@example.com" className="input-field" value={state.email} onChange={(e) => updateState("email", e.target.value)} />
                        </div>
                      </div>
                    </>
                  )}

                  {/* Phone Input */}
                  <div className="input-group">
                    <label className="static-label">
                      {state.signInStatus === "mobile-signIn" ? "Phone Number *" : "Can we get your mobile number? *"}
                    </label>
                    <PhoneInput
                      country={state.country?.value ? state.country?.value.toLowerCase() : "in"}
                      value={state.phoneNumber}
                      onChange={(phone) => updateState("phoneNumber", phone)}
                      required={true}
                      countryCodeEditable={false}
                      placeholder=""
                    />
                  </div>

                  <button type="submit" className="primary-btn">
                    {state.signInStatus === "mobile-signIn" ? "Send OTP" : "Continuee"} <Send size={18} style={{ marginLeft: "10px" }} />
                  </button>
                </form>
              </div>
            )}

            {/* ================= MENU 3: OTP VERIFICATION ================= */}
            {state.menu === 3 && (
              <div className="fade-in-up" style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "center" }}>
                <div className="text-center">
                  <h3 className="menu-title">Verify your number</h3>
                  <p className="menu-desc" style={{ lineHeight: 1.8 }}>
                    Enter the code we've sent by text to<br />
                    <span className="accent-strong">{previewPhoneNumber}</span>
                  </p>
                </div>

                <div style={{ display: "flex", justifyContent: "center", margin: "2.5rem 0" }}>
                  <div className="otp-container">
                    <OtpInput key={otpResetKey} length={6} onOtpSubmit={onOtpSubmit} />
                  </div>
                </div>

                <button onClick={verifyOtp} className="primary-btn" disabled={isVerifying}>
                  {isVerifying ? "Verifying..." : "Verify & Proceed"}
                </button>

                <div style={{ marginTop: "2rem", textAlign: "center" }}>
                  <MeetingExpiry resendOtp={submitForm} status={state.onResentOtp} />
                  <p onClick={() => { setState({ ...state, menu: 2, otp: "" }); }} className="link-muted">
                    Change Phone Number
                  </p>
                </div>
              </div>
            )}

            {/* ================= MENU 4: EMAIL REGISTER / LOGIN ================= */}
            {state.menu === 4 && (
              <div className="fade-in-up mail-wrapper">
                <div className="menu-header text-center">
                  <h3 className="menu-title">
                    {state.signInStatus === "mail-signIn" ? "Sign In with Email" : "Register with Email"}
                  </h3>
                  <p className="menu-desc">Please enter your credentials below.</p>
                </div>

                <MailRegister signIn={state.signInStatus === "mail-signIn"} emailRegisterSuccess={emailRegisterSuccess} createAccountPage={createAccountPage} />
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default withRouter(AuthContainer);